import React, { useEffect, useRef, useState } from 'react';
import { addData, deleteFile, deleteFileByUrl, getData, handleFireBaseUpload } from '../Firebase/firestore';
import { db } from '../firebase';
import './resources.css'
import sh from '../assets/search.png'

const BUTTON_TARGETS = {
    Coat: ['Suits', 'blazer', 'kurta'],
    Pant: ['Suits', 'formal'],
    Shirt: ['Suits', 'formal'],
    Vest: ['Suits'],
    Pajama: ['kurta'],
    Sadri: ['kurta'],
    Kurta: ['kurta']
};

const BUTTON_FILTERS = ['recent uploaded', 'metal', 'plastic', 'wood', 'fabric', 'ring'];

function Button_upload() {
    const [formData, setFormData] = useState({
        name: '',
        targetType: 'Coat',
        parentCategory: BUTTON_TARGETS.Coat[0],
        style: 'formal',
        color: '',
        material: 'metal',
        fabricId: '',
        icon: null,
        resources: [],
        other_images: []
    });
    useEffect(() => {
        const allowedCategories = BUTTON_TARGETS[formData.targetType] || [];
        if (!allowedCategories.includes(formData.parentCategory) && allowedCategories.length > 0) {
            setFormData((prev) => ({ ...prev, parentCategory: allowedCategories[0] }));
        }
    }, [formData.targetType, formData.parentCategory]);

    
    const [Buttons, setButtons] = useState([]);
    const [loading, setLoading] = useState(false);
    const [iconPreview, setIconPreview] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadTotal, setUploadTotal] = useState(0);
    const [uploadStatus, setUploadStatus] = useState('');
    const [successModal, setSuccessModal] = useState(null);
    const [deletingUpload, setDeletingUpload] = useState(false);
    const [deleteConfirm, setDeleteConfirm] = useState({ open: false, button: null });
    const [deletingCard, setDeletingCard] = useState(false);

    const [fabrics, setFabrics] = useState([]);

    const [editRowId, setEditRowId] = useState(null);
    const [editIcon, setEditIcon] = useState(null);
    const [editIconPreview, setEditIconPreview] = useState(null);
    const [editLoading, setEditLoading] = useState(false);
    const [buttonFilter, setButtonFilter] = useState('recent uploaded');
    const [buttonSearch, setButtonSearch] = useState('');
    const [buttonTargetFilter, setButtonTargetFilter] = useState('');

    const [change, setChange] = useState(0);
    const [targetDropdownOpen, setTargetDropdownOpen] = useState(false);
    const [parentDropdownOpen, setParentDropdownOpen] = useState(false);
    const [styleDropdownOpen, setStyleDropdownOpen] = useState(false);
    const [materialDropdownOpen, setMaterialDropdownOpen] = useState(false);
    const [buttonTargetFilterOpen, setButtonTargetFilterOpen] = useState(false);
    const targetDropdownRef = useRef(null);
    const parentDropdownRef = useRef(null);
    const styleDropdownRef = useRef(null);
    const materialDropdownRef = useRef(null);
    const buttonTargetFilterRef = useRef(null);

    const [fabricPickerOpen, setFabricPickerOpen] = useState(false);
    const [selectedFabricObj, setSelectedFabricObj] = useState(null);
    const [fabricPickerSearch, setFabricPickerSearch] = useState('');
    const [fabricPickerBrandFilter, setFabricPickerBrandFilter] = useState('');
    const [fabricPickerTypeFilter, setFabricPickerTypeFilter] = useState('');
    const [fabricPickerBrandOpen, setFabricPickerBrandOpen] = useState(false);
    const [fabricPickerTypeOpen, setFabricPickerTypeOpen] = useState(false);
    const fabricPickerBrandRef = useRef(null);
    const fabricPickerTypeRef = useRef(null);

    useEffect(()=>{
        const fetchButtons = async() => {
            const buttonsCollection = db.collection('Buttons');
            const buttonsData = await getData(buttonsCollection);
            setButtons(buttonsData);
        };
        const fetchFabrics = async() => {
            const collection = db.collection('Fabric').doc('Suits').collection('fabrics');
            const fabricsData = await getData(collection);
            setFabrics(fabricsData);
        };
        fetchButtons();
        fetchFabrics();
    }, [change]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (targetDropdownRef.current && !targetDropdownRef.current.contains(event.target)) {
                setTargetDropdownOpen(false);
            }
            if (parentDropdownRef.current && !parentDropdownRef.current.contains(event.target)) {
                setParentDropdownOpen(false);
            }
            if (styleDropdownRef.current && !styleDropdownRef.current.contains(event.target)) {
                setStyleDropdownOpen(false);
            }
            if (materialDropdownRef.current && !materialDropdownRef.current.contains(event.target)) {
                setMaterialDropdownOpen(false);
            }
            if (buttonTargetFilterRef.current && !buttonTargetFilterRef.current.contains(event.target)) {
                setButtonTargetFilterOpen(false);
            }
            if (fabricPickerBrandRef.current && !fabricPickerBrandRef.current.contains(event.target)) {
                setFabricPickerBrandOpen(false);
            }
            if (fabricPickerTypeRef.current && !fabricPickerTypeRef.current.contains(event.target)) {
                setFabricPickerTypeOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleNameChange = (e) => {
        setFormData({ ...formData, name: e.target.value });
    };

    const handleIconUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData({ ...formData, icon: file });
            const reader = new FileReader();
            reader.onload = () => {
                setIconPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleOtherImagesUpload = (e) => {
        const files = Array.from(e.target.files);
        setFormData({ ...formData, other_images: [...formData.other_images, ...files] });
    };

    const handleTargetTypeChange = (e) => {
        const selectedType = e.target.value;
        const allowedCategories = BUTTON_TARGETS[selectedType] || [];
        setFormData({
            ...formData,
            targetType: selectedType,
            parentCategory: allowedCategories.length > 0 ? allowedCategories[0] : ''
        });
    };

    const handleParentCategoryChange = (e) => {
        setFormData({ ...formData, parentCategory: e.target.value });
    };

    const handleStyleChange = (e) => {
        setFormData({ ...formData, style: e.target.value });
    };

    const handleColorChange = (e) => {
        setFormData({ ...formData, color: e.target.value });
    };

    const handleMaterialChange = (e) => {
        setFormData({ ...formData, material: e.target.value });
    };

    const handleFabricChange = (e) => {
        setFormData({ ...formData, fabricId: e.target.value });
    };

    const handleResourcesUpload = (e) => {
        const files = Array.from(e.target.files);
        setFormData({ ...formData, resources: [...formData.resources, ...files] });
    };

    const removeResource = (index) => {
        const newResources = formData.resources.filter((_, i) => i !== index);
        setFormData({ ...formData, resources: newResources });
    };

    const startEdit = (button) => {
        setEditRowId(button.id);
        setFormData({
            name: button.name || '',
            targetType: button.targetType || 'Coat',
            parentCategory: button.parentCategory || button.type || (BUTTON_TARGETS[button.targetType || 'Coat'] || ['Suits'])[0],
            style: button.style || 'formal',
            color: button.color || '',
            material: button.material || 'metal',
            fabricId: button.fabricId || '',
            icon: null,
            resources: [],
            other_images: []
        });
        setIconPreview(button.src || null);
        setEditIcon(null);
        setEditIconPreview(button.src || null);
        setEditLoading(false);

        if ((button.material || '').toLowerCase() === 'fabric' && button.fabricId) {
            const matched = (fabrics || []).find((f) => f.name === button.fabricId || f.id === button.fabricId);
            if (matched) setSelectedFabricObj(matched);
        } else {
            setSelectedFabricObj(null);
        }

        try {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (err) { /* ignore */ }
    };

    const handleRowIconChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setEditIcon(file);
            setEditIconPreview(URL.createObjectURL(file));
            setFormData((prev) => ({ ...prev, icon: file }));
            setIconPreview(URL.createObjectURL(file));
        }
    };

    const cancelEdit = () => {
        setEditRowId(null);
        setEditIcon(null);
        setEditIconPreview(null);
        setEditLoading(false);
        setIconPreview(null);
        setSelectedFabricObj(null);
        setFormData({
            name: '',
            targetType: 'Coat',
            parentCategory: 'Suits',
            style: 'formal',
            color: '',
            material: 'metal',
            fabricId: '',
            icon: null,
            resources: [],
            other_images: []
        });
    };

    const handleUpdateButton = async () => {
        if (!editRowId) return;
        const current = Buttons.find((b) => b.id === editRowId);
        if (!current) return;
        if (!formData.name || formData.name.trim().length === 0 || !formData.style || !formData.material) {
            alert('Please fill name, style and material before saving.');
            return;
        }
        if (formData.material === 'fabric' && !formData.fabricId) {
            alert('Please select a fabric for this button.');
            return;
        }
        setEditLoading(true);
        const id = current.id;
        const type = current.parentCategory || current.type || 'suit';
        let newSrc = current.src;
        const storageBasePath = `Buttons/${type}/${current.targetType || ''}/${id}`;

        try {
            if (editIcon) {
                try { await deleteFileByUrl(current.src); } catch (err) { /* ignore */ }
                newSrc = await handleFireBaseUpload(`${id}_icon`, editIcon, storageBasePath);
            }

            const updateData = {
                name: formData.name,
                targetType: formData.targetType,
                parentCategory: formData.parentCategory,
                type: formData.parentCategory,
                style: formData.style,
                color: formData.color,
                material: formData.material,
                fabricId: formData.fabricId,
                src: newSrc
            };

            await db.collection('Buttons').doc(id).update(updateData);

            setButtons((prev) => prev.map((item) => item.id === id ? { ...item, ...updateData } : item));
            cancelEdit();
        } catch (error) {
            console.error('Error updating button:', error);
            alert('Failed to update the button. Please try again.');
        } finally {
            setEditLoading(false);
        }
    };

    const handleDeleteButton = async (button) => {
        if (!button) return;
        try {
            setDeletingCard(true);
            const urls = [
                ...(button.src ? [button.src] : []),
                ...Object.values(button.resources || {}),
                ...(button.other_images || []),
            ];
            await Promise.all(urls.map((url) => deleteFileByUrl(url)));

            const coll_ref = db.collection('Buttons');
            const styleRef = coll_ref.doc(button.id).collection('style');
            const resourceKeys = Object.keys(button.resources || {});
            await Promise.all(resourceKeys.map((k) => styleRef.doc(k).delete()));
            await coll_ref.doc(button.id).delete();

            setButtons((prev) => prev.filter((b) => b.id !== button.id));
            setDeleteConfirm({ open: false, button: null });
        } catch (error) {
            console.log('delete button error', error);
            alert('Unable to delete the button. Please try again.');
        } finally {
            setDeletingCard(false);
        }
    };

    const handleSubmit = async(e) => {
        e.preventDefault();
        if (!formData.icon || formData.resources.length === 0 || formData.name.length === 0 || !formData.targetType || !formData.parentCategory) {
            alert('Please fill all the fields, select the garment type and outfit category, and upload the required images.');
            return;
        }
        if (formData.material === 'fabric' && !formData.fabricId) {
            alert('Please select a fabric for this button.');
            return;
        }

        const total = 1 + (formData.resources?.length || 0) + (formData.other_images?.length || 0);
        setUploadTotal(total);
        setUploadProgress(0);
        setLoading(true);

        try {
            const id = new Date().getTime().toString();
            const storageBasePath = `Buttons/${formData.parentCategory}/${formData.targetType}/${id}`;

            setUploadStatus('Uploading icon image...');
            const icon_url = await handleFireBaseUpload(`${id}_icon`, formData.icon, storageBasePath);
            setUploadProgress((p) => p + 1);

            setUploadStatus('Uploading render images...');
            const resource_urls = {};
            for (let i = 0; i < formData.resources.length; i++) {
                const url = await handleFireBaseUpload(`${id}_resource_${i}`, formData.resources[i], storageBasePath);
                resource_urls[`${formData.resources[i].name.replace(" ", "").split(".")[0]}`] = url;
                setUploadProgress((p) => p + 1);
            }

            setUploadStatus('Uploading other images...');
            const other_images_urls = [];
            for (let i = 0; i < formData.other_images.length; i++) {
                const url = await handleFireBaseUpload(`${id}_other_image_${i}`, formData.other_images[i], storageBasePath);
                other_images_urls.push(url);
                setUploadProgress((p) => p + 1);
            }

            setUploadStatus('Saving to database...');
            const coll_ref = db.collection('Buttons');
            const styleRef = coll_ref.doc(id).collection("style");

            var batch = db.batch();
            Object.keys(resource_urls).forEach((doc1) => {
                var docRef = styleRef.doc(doc1);
                batch.set(docRef, { "src": resource_urls[doc1] });
            });
            await batch.commit();

            await addData(coll_ref, id, {
                id,
                name: formData.name,
                type: formData.parentCategory,
                targetType: formData.targetType,
                parentCategory: formData.parentCategory,
                style: formData.style,
                color: formData.color,
                material: formData.material,
                fabricId: formData.fabricId,
                src: icon_url,
                resources: resource_urls,
                other_images: other_images_urls
            });
            setChange(change + 1);

            setSuccessModal({
                id,
                name: formData.name,
                targetType: formData.targetType,
                parentCategory: formData.parentCategory,
                style: formData.style,
                material: formData.material,
                fabric: selectedFabricObj?.name || formData.fabricId || '-',
                resourcesCount: Object.keys(resource_urls).length,
                otherCount: other_images_urls.length,
                iconUrl: icon_url,
                resourceUrls: Object.values(resource_urls),
                resourceKeys: Object.keys(resource_urls),
                otherUrls: other_images_urls,
            });

            setIconPreview(null);
            setSelectedFabricObj(null);
            setFormData({
                name: '',
                targetType: 'Coat',
                parentCategory: 'Suits',
                style: 'formal',
                color: '',
                material: 'metal',
                fabricId: '',
                icon: null,
                resources: [],
                other_images: []
            });
        } catch (err) {
            console.log('Button upload failed:', err);
            alert('Upload failed. Please try again.');
        } finally {
            setLoading(false);
            setUploadStatus('');
        }
    };

    const deleteUploadedButton = async () => {
        if (!successModal) return;
        try {
            setDeletingUpload(true);
            const urls = [
                ...(successModal.iconUrl ? [successModal.iconUrl] : []),
                ...(successModal.resourceUrls || []),
                ...(successModal.otherUrls || []),
            ];
            await Promise.all(urls.map((url) => deleteFileByUrl(url)));

            const coll_ref = db.collection('Buttons');
            const styleRef = coll_ref.doc(successModal.id).collection('style');
            await Promise.all((successModal.resourceKeys || []).map((k) => styleRef.doc(k).delete()));
            await coll_ref.doc(successModal.id).delete();

            setChange((c) => c + 1);
            setSuccessModal(null);
        } catch (error) {
            console.log('delete uploaded button', error);
            alert('Unable to delete the uploaded button.');
        } finally {
            setDeletingUpload(false);
        }
    };

    const filteredButtons = [...Buttons]
        .filter((item) => {
            if (buttonFilter === 'recent uploaded') {
                return true;
            }
            return (item.material || '').toLowerCase() === buttonFilter;
        })
        .filter((item) => {
            if (!buttonSearch) {
                return true;
            }
            const term = buttonSearch.toLowerCase();
            return JSON.stringify(item).toLowerCase().includes(term);
        })
        .filter((item) => {
            if (!buttonTargetFilter) {
                return true;
            }
            return (item.targetType || '').toLowerCase() === buttonTargetFilter.toLowerCase();
        })
        .sort((a, b) => {
            const aTime = new Date(a.created || a.id || 0).getTime() || Number(a.id) || 0;
            const bTime = new Date(b.created || b.id || 0).getTime() || Number(b.id) || 0;
            return bTime - aTime;
        });

    return ( 
        <div className="button_upload_page button-upload-premium-page">
            <div className="button_upload_form fabric-modern button-upload-premium-form">
                {editRowId && (
                    <div className="button-upload-edit-banner">
                        <div>
                            <span className="button-upload-edit-badge">Editing</span>
                            <strong>{formData.name || 'Button'}</strong>
                        </div>
                        <button type="button" className="button-upload-edit-banner-cancel" onClick={cancelEdit} disabled={editLoading}>
                            Cancel
                        </button>
                    </div>
                )}
                <form
                    onSubmit={(e) => { e.preventDefault(); if (editRowId) { handleUpdateButton(); } else { handleSubmit(e); } }}
                    className="button-upload-premium-fields"
                >
                    {/* Name Field - Optional */}
                    <div className="f-inputs">
                        <label className="button-upload-label">
                            Name <span className="text-gray-400">*</span>
                        </label>
                        <input 
                            type="text"
                            placeholder="Enter name"
                            name="name"
                            value={formData.name}
                            onChange={handleNameChange}
                            
                        />
                    </div>

                    {/* Kiska Button */}
                    <div className="f-inputs" ref={targetDropdownRef}>
                        <label className="button-upload-label">
                            Button For <span className="text-gray-400">*</span>
                        </label>
                        <div className="fabric-custom-select">
                            <button type="button" className="fabric-custom-select-trigger" onClick={() => setTargetDropdownOpen((v) => !v)}>
                                <span>{formData.targetType}</span>
                                <span className={`fabric-custom-select-arrow ${targetDropdownOpen ? "open" : ""}`}>▾</span>
                            </button>
                            {targetDropdownOpen && (
                                <div className="fabric-custom-select-menu">
                                    {Object.keys(BUTTON_TARGETS).map((target) => (
                                        <button
                                            type="button"
                                            key={target}
                                            className={`fabric-custom-select-option ${formData.targetType === target ? "active" : ""}`}
                                            onClick={() => {
                                                handleTargetTypeChange({ target: { value: target } });
                                                setTargetDropdownOpen(false);
                                            }}
                                        >
                                            {target}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Kiske Andar */}
                    <div className="f-inputs" ref={parentDropdownRef}>
                        <label className="button-upload-label">
                            Outfit Category <span className="text-gray-400">*</span>
                        </label>
                        <div className="fabric-custom-select">
                            <button type="button" className="fabric-custom-select-trigger" onClick={() => setParentDropdownOpen((v) => !v)}>
                                <span>{formData.parentCategory}</span>
                                <span className={`fabric-custom-select-arrow ${parentDropdownOpen ? "open" : ""}`}>▾</span>
                            </button>
                            {parentDropdownOpen && (
                                <div className="fabric-custom-select-menu">
                                    {(BUTTON_TARGETS[formData.targetType] || []).map((category) => (
                                        <button
                                            type="button"
                                            key={category}
                                            className={`fabric-custom-select-option ${formData.parentCategory === category ? "active" : ""}`}
                                            onClick={() => {
                                                handleParentCategoryChange({ target: { value: category } });
                                                setParentDropdownOpen(false);
                                            }}
                                        >
                                            {category}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Style Selector */}
                    <div className="f-inputs" ref={styleDropdownRef}>
                        <label className="button-upload-label">
                            Style
                        </label>
                        <div className="fabric-custom-select">
                            <button type="button" className="fabric-custom-select-trigger" onClick={() => setStyleDropdownOpen((v) => !v)}>
                                <span>{formData.style === "formal" ? "Formal" : "Fancy"}</span>
                                <span className={`fabric-custom-select-arrow ${styleDropdownOpen ? "open" : ""}`}>▾</span>
                            </button>
                            {styleDropdownOpen && (
                                <div className="fabric-custom-select-menu">
                                    {["formal", "fancy"].map((style) => (
                                        <button
                                            type="button"
                                            key={style}
                                            className={`fabric-custom-select-option ${formData.style === style ? "active" : ""}`}
                                            onClick={() => {
                                                handleStyleChange({ target: { value: style } });
                                                setStyleDropdownOpen(false);
                                            }}
                                        >
                                            {style === "formal" ? "Formal" : "Fancy"}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Color Input */}
                    <div className="f-inputs">
                        <label className="button-upload-label">
                            Color (Hex Code)
                        </label>
                        <input 
                            type="text"
                            placeholder="e.g., #FF0000"
                            value={formData.color}
                            onChange={handleColorChange}
                            required
                        />
                    </div>

                    {/* Material Selector */}
                    <div className="f-inputs" ref={materialDropdownRef}>
                        <label className="button-upload-label">
                            Material
                        </label>
                        <div className="fabric-custom-select">
                            <button type="button" className="fabric-custom-select-trigger" onClick={() => setMaterialDropdownOpen((v) => !v)}>
                                <span>{formData.material.charAt(0).toUpperCase() + formData.material.slice(1)}</span>
                                <span className={`fabric-custom-select-arrow ${materialDropdownOpen ? "open" : ""}`}>▾</span>
                            </button>
                            {materialDropdownOpen && (
                                <div className="fabric-custom-select-menu">
                                    {["metal", "plastic", "wood", "fabric", "ring"].map((material) => (
                                        <button
                                            type="button"
                                            key={material}
                                            className={`fabric-custom-select-option ${formData.material === material ? "active" : ""}`}
                                            onClick={() => {
                                                handleMaterialChange({ target: { value: material } });
                                                setMaterialDropdownOpen(false);
                                            }}
                                        >
                                            {material.charAt(0).toUpperCase() + material.slice(1)}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Fabric Selector - only when material is Fabric */}
                    {(formData.material || '').toLowerCase() === 'fabric' && (
                    <div className="f-inputs">
                        <label className="button-upload-label">
                            Fabric <span className="text-red-500">*</span>
                        </label>
                        <div className={`outfit-inline-fabric-select button-fabric-picker ${selectedFabricObj ? "outfit-inline-fabric-select-active" : ""}`}>
                            {selectedFabricObj ? (
                                <div className="outfit-inline-fabric-value">
                                    <img src={selectedFabricObj.src} alt={selectedFabricObj.name} />
                                    <div className="outfit-inline-fabric-copy">
                                        <strong>{selectedFabricObj.name}</strong>
                                        <span>
                                            {selectedFabricObj.brand || '-'}
                                            {selectedFabricObj.color ? ` | ${selectedFabricObj.color}` : ''}
                                        </span>
                                        <small>Click Change to pick another fabric</small>
                                    </div>
                                    <div className="button-fabric-picker-actions">
                                        <button
                                            type="button"
                                            className="outfit-inline-fabric-remove"
                                            onClick={() => setFabricPickerOpen(true)}
                                        >
                                            Change
                                        </button>
                                        <button
                                            type="button"
                                            className="outfit-inline-fabric-remove button-fabric-picker-clear"
                                            onClick={() => {
                                                setSelectedFabricObj(null);
                                                setFormData({ ...formData, fabricId: '' });
                                            }}
                                        >
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <button
                                    type="button"
                                    className="button-fabric-picker-trigger"
                                    onClick={() => setFabricPickerOpen(true)}
                                >
                                    <span className="button-fabric-picker-trigger-label">Select any fabric</span>
                                    <span className="button-fabric-picker-trigger-arrow">›</span>
                                </button>
                            )}
                        </div>
                    </div>
                    )}

                    {/* Icon Upload */}
                    <div className="f-inputs">
                        <div className="fabric-file-title"><b>{editRowId ? 'Change Icon' : 'Icon Image'} {!editRowId && (<span className="text-red-500">*</span>)}</b></div>
                        <input
                            className="fabric-file-input"
                            type="file"
                            accept="image/*"
                            onChange={editRowId ? handleRowIconChange : handleIconUpload}
                            required={!editRowId}
                        />
                        {iconPreview && (
                            <div className="button-upload-preview">
                                <p className="button-upload-preview-title">Icon Preview</p>
                                <img
                                    src={iconPreview}
                                    alt="Icon preview"
                                    className="button-upload-preview-image"
                                />
                            </div>
                        )}
                    </div>

                    {!editRowId && (
                        <>
                            {/* Other images Upload */}
                            <div className="f-inputs">
                                <div className="fabric-file-title"><b>Other Images</b></div>
                                <input
                                    className="fabric-file-input"
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    onChange={handleOtherImagesUpload}
                                />
                            </div>

                            {/* Resources Upload - Required */}
                            <div className="f-inputs">
                                <div className="fabric-file-title"><b>Upload Render <span className="text-red-500">*</span></b></div>
                                <input
                                    className="fabric-file-input"
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    onChange={handleResourcesUpload}
                                    required
                                />
                            </div>
                        </>
                    )}

                    {/* Submit Button */}
                    {loading ? (
                        <div className="outfit-upload-progress">
                            <div className="outfit-upload-progress-top">
                                <span>{uploadStatus || 'Uploading...'}</span>
                                <strong>{uploadTotal ? Math.floor((uploadProgress / uploadTotal) * 100) : 0}%</strong>
                            </div>
                            <div className="outfit-upload-progress-track">
                                <div
                                    className="outfit-upload-progress-fill"
                                    style={{ width: `${uploadTotal ? (uploadProgress / uploadTotal) * 100 : 0}%` }}
                                />
                            </div>
                            <div className="outfit-upload-progress-meta">
                                {uploadProgress} / {uploadTotal} files uploaded
                            </div>
                        </div>
                    ) : editRowId ? (
                        <div className="button-upload-edit-actions">
                            <button
                                type="button"
                                className="fabric-submit-btn button-upload-cancel-btn"
                                onClick={cancelEdit}
                                disabled={editLoading}
                            >
                                Cancel
                            </button>
                            <button
                                className="fabric-submit-btn"
                                type="submit"
                                disabled={editLoading}
                            >
                                {editLoading ? 'Saving...' : 'Save Changes'}
                            </button>
                        </div>
                    ) : (
                        <button
                            className="fabric-submit-btn"
                            type="submit"
                        >
                            Upload Button
                        </button>
                    )}
                </form>
            </div>

            <div className="button-upload-list-shell">
            <h2 className="button-upload-list-title">Uploaded Buttons</h2>
            <div className="button-upload-filterbar">
                <div className="button-upload-filter-switcher">
                    {BUTTON_FILTERS.map((filter) => (
                        <button
                            key={filter}
                            type="button"
                            className={`button-upload-filter-chip ${buttonFilter === filter ? 'button-upload-filter-chip-active' : ''}`}
                            onClick={() => setButtonFilter(filter)}
                        >
                            {filter === 'recent uploaded' ? 'Recent Uploaded' : filter.charAt(0).toUpperCase() + filter.slice(1)}
                        </button>
                    ))}
                </div>
                <div className="button-upload-target-filter" ref={buttonTargetFilterRef}>
                    <div className="fabric-custom-select">
                        <button type="button" className="fabric-custom-select-trigger edit-fabric-select-trigger" onClick={() => setButtonTargetFilterOpen((v) => !v)}>
                            <span>{buttonTargetFilter || "All Items"}</span>
                            <span className={`fabric-custom-select-arrow ${buttonTargetFilterOpen ? "open" : ""}`}>▾</span>
                        </button>
                        {buttonTargetFilterOpen && (
                            <div className="fabric-custom-select-menu">
                                <button type="button" className={`fabric-custom-select-option ${buttonTargetFilter === "" ? "active" : ""}`} onClick={() => { setButtonTargetFilter(""); setButtonTargetFilterOpen(false); }}>All Items</button>
                                {Object.keys(BUTTON_TARGETS).map((target) => (
                                    <button
                                        type="button"
                                        key={target}
                                        className={`fabric-custom-select-option ${buttonTargetFilter === target ? "active" : ""}`}
                                        onClick={() => {
                                            setButtonTargetFilter(target);
                                            setButtonTargetFilterOpen(false);
                                        }}
                                    >
                                        {target}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <div className="edit-fabric-search-box button-upload-search-box">
                    <input
                        className="search_fabric_clothes"
                        placeholder="Search button"
                        value={buttonSearch}
                        onChange={(e) => setButtonSearch(e.target.value)}
                    />
                    <img src={sh} alt="Search" />
                </div>
            </div>
            <div className='button_uploads button-upload-list'>
                
                {filteredButtons.map((e, i)=>{
                    return <div className='button_upload_card button-upload-premium-card' key={e.id || i}>
                        <div className="button-upload-card-actions">
                            <button type='button' className="button-upload-edit-icon-btn" onClick={() => startEdit(e)} aria-label="Edit button">
                                ✎
                            </button>
                            <button type='button' className="button-upload-edit-icon-btn button-upload-delete-icon-btn" onClick={() => setDeleteConfirm({ open: true, button: e })} aria-label="Delete button">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <polyline points="3 6 5 6 21 6"></polyline>
                                    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                                    <path d="M10 11v6M14 11v6"></path>
                                    <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"></path>
                                </svg>
                            </button>
                        </div>
                        <div className="button-upload-card-image-wrap">
                            <img src={e.src} alt={e.name || 'Button'} className="button-upload-card-image" />
                        </div>
                        <div className="button-upload-card-details">
                            <div className="button-upload-card-name" title={e.name || '-'}>{e.name || 'Untitled'}</div>
                            <div className="button-upload-card-specs">
                                <div className="button-upload-spec-row">
                                    <span className="button-upload-spec-label">Material</span>
                                    <span className="button-upload-spec-value">{e.material || '-'}</span>
                                </div>
                                <div className="button-upload-spec-row">
                                    <span className="button-upload-spec-label">Target</span>
                                    <span className="button-upload-spec-value">{e.targetType || '-'}</span>
                                </div>
                                <div className="button-upload-spec-row">
                                    <span className="button-upload-spec-label">Type</span>
                                    <span className="button-upload-spec-value">{e.type || e.parentCategory || '-'}</span>
                                </div>
                                <div className="button-upload-spec-row">
                                    <span className="button-upload-spec-label">Style</span>
                                    <span className="button-upload-spec-value">{e.style || '-'}</span>
                                </div>
                                {(e.material || '').toLowerCase() === 'fabric' ? (
                                    <div className="button-upload-spec-row">
                                        <span className="button-upload-spec-label">Fabric</span>
                                        <span className="button-upload-spec-value">{e.fabricId || '-'}</span>
                                    </div>
                                ) : (
                                    <div className="button-upload-spec-row">
                                        <span className="button-upload-spec-label">Color</span>
                                        <span className="button-upload-spec-value button-upload-spec-color">
                                            {e.color ? (
                                                <>
                                                    <span className="button-upload-color-dot" style={{ background: e.color }}></span>
                                                    <span className="button-upload-color-hex">{e.color}</span>
                                                </>
                                            ) : '-'}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                })
                }

            </div>
            </div>

            {fabricPickerOpen && (() => {
                const brandsList = Array.from(new Set((fabrics || []).map((f) => f.brand).filter(Boolean)))
                const typesList = Array.from(new Set((fabrics || []).map((f) => f.fabricType).filter(Boolean)))
                const filteredFabrics = (fabrics || []).filter((f) => {
                    if (fabricPickerBrandFilter && String(f.brand || '').toLowerCase() !== fabricPickerBrandFilter.toLowerCase()) return false
                    if (fabricPickerTypeFilter && String(f.fabricType || '').toLowerCase() !== fabricPickerTypeFilter.toLowerCase()) return false
                    if (fabricPickerSearch && !JSON.stringify(f).toLowerCase().includes(fabricPickerSearch.toLowerCase())) return false
                    return true
                })
                return (
                    <div className="recom-modal-backdrop" onClick={() => setFabricPickerOpen(false)}>
                        <div className="recom-modal button-fabric-picker-modal" onClick={(ev) => ev.stopPropagation()}>
                            <div className="recom-modal-header">
                                <div>
                                    <h3>Select Fabric</h3>
                                    <p>Pick a fabric to link with this button. {filteredFabrics.length} fabric{filteredFabrics.length === 1 ? '' : 's'} available.</p>
                                </div>
                                <button type="button" className="recom-modal-close" onClick={() => setFabricPickerOpen(false)} aria-label="Close">×</button>
                            </div>

                            <div className="recom-modal-filterbar">
                                <div className="button-fabric-picker-filters">
                                    <div className="button-fabric-picker-filter" ref={fabricPickerBrandRef}>
                                        <div className="fabric-custom-select">
                                            <button type="button" className="fabric-custom-select-trigger edit-fabric-select-trigger" onClick={() => setFabricPickerBrandOpen((v) => !v)}>
                                                <span>{fabricPickerBrandFilter || 'All Brands'}</span>
                                                <span className={`fabric-custom-select-arrow ${fabricPickerBrandOpen ? 'open' : ''}`}>▾</span>
                                            </button>
                                            {fabricPickerBrandOpen && (
                                                <div className="fabric-custom-select-menu">
                                                    <button type="button" className={`fabric-custom-select-option ${fabricPickerBrandFilter === '' ? 'active' : ''}`} onClick={() => { setFabricPickerBrandFilter(''); setFabricPickerBrandOpen(false); }}>All Brands</button>
                                                    {brandsList.map((val) => (
                                                        <button type="button" key={val} className={`fabric-custom-select-option ${fabricPickerBrandFilter === val ? 'active' : ''}`} onClick={() => { setFabricPickerBrandFilter(val); setFabricPickerBrandOpen(false); }}>{val}</button>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="button-fabric-picker-filter" ref={fabricPickerTypeRef}>
                                        <div className="fabric-custom-select">
                                            <button type="button" className="fabric-custom-select-trigger edit-fabric-select-trigger" onClick={() => setFabricPickerTypeOpen((v) => !v)}>
                                                <span>{fabricPickerTypeFilter || 'All Types'}</span>
                                                <span className={`fabric-custom-select-arrow ${fabricPickerTypeOpen ? 'open' : ''}`}>▾</span>
                                            </button>
                                            {fabricPickerTypeOpen && (
                                                <div className="fabric-custom-select-menu">
                                                    <button type="button" className={`fabric-custom-select-option ${fabricPickerTypeFilter === '' ? 'active' : ''}`} onClick={() => { setFabricPickerTypeFilter(''); setFabricPickerTypeOpen(false); }}>All Types</button>
                                                    {typesList.map((val) => (
                                                        <button type="button" key={val} className={`fabric-custom-select-option ${fabricPickerTypeFilter === val ? 'active' : ''}`} onClick={() => { setFabricPickerTypeFilter(val); setFabricPickerTypeOpen(false); }}>{val}</button>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="recom-modal-search">
                                    <input type="text" placeholder="Search fabric by name, brand, color..." value={fabricPickerSearch} onChange={(ev) => setFabricPickerSearch(ev.target.value)} />
                                    <img src={sh} alt="Search" />
                                </div>
                            </div>

                            <div className="recom-modal-body">
                                {filteredFabrics.length === 0 ? (
                                    <div className="recom-modal-empty">
                                        No fabrics found{fabricPickerBrandFilter ? ` for brand ${fabricPickerBrandFilter}` : ''}{fabricPickerTypeFilter ? ` of type ${fabricPickerTypeFilter}` : ''}{fabricPickerSearch ? ` matching "${fabricPickerSearch}"` : ''}.
                                    </div>
                                ) : (
                                    <div className="button-fabric-picker-grid">
                                        {filteredFabrics.map((f) => {
                                            const isSelected = selectedFabricObj && selectedFabricObj.id === f.id
                                            return (
                                                <div
                                                    key={f.id}
                                                    className={`outfit-fabric-card ${isSelected ? 'outfit-fabric-card-active' : ''}`}
                                                    onClick={() => {
                                                        setSelectedFabricObj(f)
                                                        setFormData({ ...formData, fabricId: f.name })
                                                        setFabricPickerOpen(false)
                                                    }}
                                                >
                                                    <img src={f.src} alt={f.name} className="outfit-fabric-card-image" />
                                                    <div className="outfit-fabric-card-info">
                                                        <h5>{f.name}</h5>
                                                        <p>{f.brand || '-'}</p>
                                                        <span>{f.color || '-'}{f.width ? ` · ${f.width}` : ''}</span>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )
            })()}

            {successModal && (
                <div className="outfit-success-modal-backdrop">
                    <div className="outfit-success-modal">
                        <div className="outfit-success-modal-badge">Upload Successful</div>
                        <h3>Button uploaded successfully</h3>
                        <div className="outfit-success-modal-grid">
                            <div><span>ID</span><strong>{successModal.id}</strong></div>
                            <div><span>Name</span><strong>{successModal.name}</strong></div>
                            <div><span>Target</span><strong>{successModal.targetType}</strong></div>
                            <div><span>Category</span><strong>{successModal.parentCategory}</strong></div>
                            <div><span>Style</span><strong>{successModal.style}</strong></div>
                            <div><span>Material</span><strong>{successModal.material}</strong></div>
                            {successModal.material === 'fabric' && (
                                <div><span>Fabric</span><strong>{successModal.fabric}</strong></div>
                            )}
                            <div><span>Renders</span><strong>{successModal.resourcesCount}</strong></div>
                            <div><span>Other Images</span><strong>{successModal.otherCount}</strong></div>
                        </div>
                        <button type="button" className="fabric-submit-btn outfit-success-close" onClick={() => setSuccessModal(null)}>
                            Close
                        </button>
                        <button
                            type="button"
                            className="fabric-submit-btn outfit-delete-close"
                            onClick={() => {
                                if (deletingUpload) return;
                                if (window.confirm(`Are you sure you want to delete ${successModal?.name || 'this uploaded button'}? This action cannot be undone.`)) {
                                    deleteUploadedButton();
                                }
                            }}
                            disabled={deletingUpload}
                        >
                            {deletingUpload ? 'Deleting...' : 'Delete This Upload'}
                        </button>
                    </div>
                </div>
            )}

            {deleteConfirm.open && deleteConfirm.button && (
                <div className="recom-modal-backdrop" onClick={() => !deletingCard && setDeleteConfirm({ open: false, button: null })}>
                    <div className="recom-modal add-brand-delete-modal" onClick={(ev) => ev.stopPropagation()}>
                        <div className="recom-modal-header">
                            <div>
                                <h3>Delete Button</h3>
                                <p>Are you sure you want to delete <b>{deleteConfirm.button.name || 'this button'}</b>? This action cannot be undone.</p>
                            </div>
                            <button type="button" className="recom-modal-close" onClick={() => !deletingCard && setDeleteConfirm({ open: false, button: null })} aria-label="Close">×</button>
                        </div>
                        <div className="recom-modal-footer">
                            <div></div>
                            <div className="recom-modal-actions">
                                <button type="button" className="fabric-submit-btn recom-modal-clear" onClick={() => setDeleteConfirm({ open: false, button: null })} disabled={deletingCard}>Cancel</button>
                                <button type="button" className="fabric-submit-btn recom-modal-done add-brand-confirm-delete" onClick={() => handleDeleteButton(deleteConfirm.button)} disabled={deletingCard}>
                                    {deletingCard ? 'Deleting...' : 'Confirm Delete'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Button_upload;